

































































































































































































































































































































































































































































































import Vue from "vue";
import Numeros from "../components/Numeros.vue";
import Presenca from "../components/Presenca.vue";
import { Component } from "vue-property-decorator";

//Vue.component("numeros", Numeros);

export default {
  data() {
    return {
      dialogVideo25Anos: false,
    };
  },
  components: {
    Numeros,
    Presenca,
  },
};
